<template>
<div ui-view="" class="app-body" id="view">
	<!-- ############ PAGE START-->
		<page-header title="IDC 출입 내역 조회" description="인증심사 대응을 위해 IDC 출입 내역을 조회합니다.">
		</page-header>

	<!-- page-body -->
	<div class="page-body ph-30 book-search">
		<div class="pt-20 pb-20">
			<div class="row">
				<div class="search-item">
					<div class="input-group">
						<span class="input-group-addon title">기간선택</span>
						<DatePicker class="form-control"
												type="date"
												range
												:append-to-body="false"
												:popup-style="{ left: 0}"
												v-model="dateRange"
												style="width:220px; font-size: 12px;"
												:clearable="false"
												:editable="false"
												input-class="calendar-input">
							<i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
						</DatePicker>
					</div>
				</div>


				<div class="search-item">
					<div class="input-group">
						<dropdown v-model="searchItem.isLong" :datasource="termList" title="장/단기" :isSelectionFirstData="searchItem.isLong == null ? true :false" inline="inline"/>
					</div>
				</div>


				<div class="search-item">
					<div class="input-group">
						<dropdown v-model="searchItem.isSecure" :datasource="zoneList" title="존" :isSelectionFirstData="searchItem.isSecure == null ? true :false" inline="inline"/>
					</div>
				</div>

				<div class="search-item">
					<div class="input-group">
						<dropdown v-model="searchItem.reservationTypeList" :datasource="typeList" title="출입 타입" :isSelectionFirstData="searchItem.reservationTypeList == 'VMS,NTREE,AB등급' ? true : false" inline="inline"/>
					</div>
				</div>
			</div>


			<div class="row">
				<div class="search-item">
					<div class="input-group">
						<span class="input-group-addon title">티켓번호</span>
						<input v-model="searchItem.ntreeTicket" type="text" class="form-control" placeholder="NTREE티켓번호를 입력하세요.">
					</div>
				</div>

				<div class="search-item">
					<div class="input-group">
						<span class="input-group-addon title">이름</span>
						<input v-model="searchItem.visitorName"  type="text" class="form-control" placeholder="출입자이름을 입력하세요.">
					</div>
				</div>

				<div class="search-item">
					<div class="input-group">
						<span class="input-group-addon title">회사명</span>
						<input v-model="searchItem.visitorCompany" type="text" class="form-control" placeholder="회사명을 입력하세요.">
					</div>
				</div>

				<div class="search-item">
					<label class="md-check no-wrap pt-5 ml-8">
						<input type="checkbox" v-model="searchItem.isPermited">
						<i class="blue"></i>상주직원 포함</label>
				</div>


				<div class="search-item">
					<button class="btn btn-md line-1" @click="resetSearchItem()">Reset</button>
				</div>
				<div class="search-item">
					<button class="btn btn-md blue ml-6" @click="searchClick()">검색</button>
				</div>
				<div class="search-item" style="margin-left:auto">
					<button class="btn btn-lg line-2" @click="downloadExcel()"  title="현재 조회된 발송 목록 결과를 다운로드 가능한 Excel 파일로 생성 요청하거나, 파일 생성 요청 목록을 확인한 후 파일을 다운로드할 수 있습니다." data-toggle="tooltip" data-placement="right"><i class="icon-excel mr-5 font-size-11"></i>다운로드 요청 / 목록</button>
				</div>
			</div>

		</div>



		<data-table :datasource="items" :noDataSpan="11">
			<template v-slot:header>
				<data-table-header-column name="checked" displayName="" width="50px">
					<label class="md-check">
						<input type="checkbox" @change="check" v-model="checkedAll">
						<i class="blue"></i>
					</label>
				</data-table-header-column>
				<data-table-header-column name="ntreeTicket" displayName="티켓번호" width="15%"/>
				<data-table-header-column name="visitorName" displayName="이름" width="100px"/>
				<data-table-header-column name="visitorCompany" displayName="회사명" width="auto"/>
				<data-table-header-column name="statusCode" displayName="출입요청기간" width="auto"/>
				<data-table-header-column name="fromDate" displayName="입실시간" width="10%"/>
				<data-table-header-column name="toDate" displayName="퇴실시간" width="10%"/>
				<data-table-header-column name="empName" displayName="담당자" width="10%"/>
				<data-table-header-column name="assetList" displayName="반입요청자산" />
				<data-table-header-column name="assetList" displayName="반입자산" />
				<data-table-header-column name="more" displayName="" width="50px"/>
			</template>
			<template v-if="total != 0" v-for="(item, $index) in items">
				<tr v-bind:key="$index" :class="[selectedIndex == item.uuid ? 'expanded' : null]">
					<data-table-column name="checked" displayName="" width="50px">
						<label class="md-check">
							<input type="checkbox" v-model="item.checked" @change="checkboxChange">
							<i class="blue"></i>
						</label>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="티켓번호" :style="item.visitor.ntreeTicket ? 'cursor:pointer;color:#187ed6;' : ''" @click="goNtreeTicket(item.visitor.ntreeTicket)">
							{{item.visitor.ntreeTicket == null ? item.visitor.reservationType : item.visitor.ntreeTicket}}
							<i v-if="item.visitor.ntreeTicket" class="icon-move-link"></i>
						</span>
					</data-table-column>
					<data-table-column name="checked" displayName="" >
						<span class="td-text ellipsis" data-original-title="이름">{{item.visitor.visitorName}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="회사명">{{item.visitor.visitorCompany}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="출입요청기간">{{getDueDate(item.visitor.fromDate, item.visitor.toDate)}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="입실시간">{{item.checkInTimestamp ? getDate(item.checkInTimestamp).slice(0,-3) : '-'}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="퇴실시간">{{item.checkOutTimestamp ? getDate(item.checkOutTimestamp).slice(0,-3) : '-'}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="담당자">{{item.visitor.empName}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="반입요청자산">{{getAssetNames(item.visitor.assetList)}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<span class="td-text ellipsis" data-original-title="반입자산">{{getAccessAssetNames(item.assetList, item.visitor.assetList)}}</span>
					</data-table-column>
					<data-table-column name="checked" displayName="">
						<a @click="itemClick(item)">
							<i :class="['icon', selectedIndex == item.uuid ? 'icon-arrow-line-up' : 'icon-arrow-line-down']"></i>
						</a>
					</data-table-column>
				</tr>
				<ComplienceForm :item="item" v-bind:key="'detail-'+$index" v-if="selectedIndex == item.uuid"/>
			</template>
		</data-table>
		<Pagenation ref="paging" :datasource="resultData" @pageChange="pageChange"/>
	</div>
</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue'
import Dropdown from '@/components/Dropdown.vue';
import DataTableBase from '@/components/common/dataTableBase';
import DataTable from '@/components/common/DataTable.vue';
import DataTableHeaderColumn from '@/components/common/DataTableHeaderColumn.vue';
import DataTableColumn from '@/components/common/DataTableColumn.vue';
import Pagenation from '@/components/common/Pagenation';
import ComplienceForm from "./ComplienceForm";

export default {
	mixins: [DataTableBase],
	components: {
		ComplienceForm,
		PageHeader,
		Dropdown,
		DataTableBase,
		DataTable,
		DataTableColumn,
		DataTableHeaderColumn,
		Pagenation
	},
	data(){
    return {
			searchItem: {
				isLong: null,
				isSecure: null,
				reservationTypeList: null,
				ntreeTicket: null,
				visitorName: null,
				visitorCompany: null,
				isPermited: false
			},
			dateRange: null,
			zoneList: [{name: '전체', value: null, isChecked: true}, {name: '일반존', value: '0'}, {name: '공공금융존', value: 1}],
			termList: [{name: '전체', value: null, isChecked: true}, {name: '장기출입자', value: '1'}, {name: '단기출입자', value: 0}],
			typeList: [{name: '전체', value:'VMS,NTREE,AB등급', isChecked: true}, {name: '일반출입자', value: 'VMS,NTREE'}, {name: 'AB등급', value:'AB등급'}],
			paging: this.$dataProvider.paging,
			resultData : null,
			getApi:'visitor/history',
    }
  },
	computed: {
		getAssetNames() {
			return (assets) => {
				return _.map(assets, x => x.visitorAssetCode.assetStr).join(', ')
				//return assets
			}
		},
		getAccessAssetNames() {
			return (accessStr, reserve) => {
				let accessList = JSON.parse(accessStr);

				let filtered = reserve.filter(x=>{
					return accessList.includes('' + x.visitorAssetIndex);
				});

				return this.getAssetNames(filtered);
			}
		},
		currentIdc(){
			return this.$store.state.location.currentIdc;
		}
	},
	watch: {
		currentIdc(nVal, oVal){
			this.init();
		}
	},
	mounted(){
		this.init();
	},
	methods: {
		init() {
			let query = Object.assign({},this.$route.query);


			this.searchItem = query;
			if(!this.searchItem.fromDate) this.searchItem.fromDate = Date.now();
			if(!this.searchItem.toDate) this.searchItem.toDate = Date.now();

			if(!query.reservationTypeList) this.searchItem.reservationTypeList='VMS,NTREE,AB등급';
			if(!this.typeList.map(x=> x.value).includes(this.searchItem.reservationTypeList)) this.searchItem.reservationTypeList='VMS,NTREE,AB등급';

			this.dateRange = [moment(Number(this.searchItem.fromDate)).toDate(), moment(Number(this.searchItem.toDate)).toDate()];


			if(!query.limit || !query.offset){
				Object.entries(this.paging).forEach((data) => {
					query[data[0]] = data[1];
				});
			}
			query.visitIdcCode = this.currentIdc.locationCode;

			this.$router.push({query: query}).then(() => {
				this.findAll();
			}).catch((e) => {
				this.findAll();
			});
		},


		pageChange(event){

			if(event) this.paging = event.data;
			let query = Object.assign({},this.$route.query);
			// this.searchTypeList.forEach((x) => {delete query[x.value]})
			query.limit = this.paging.limit;
			query.offset = this.paging.offset;
			this.$router.push({ path: this.$route.path, query: query});

			this.findAll();
		},


		searchClick(){
			var query = this.searchSetting();

			query.offset = 1;
			this.$router.push({query: query}).then(() => {
				this.findAll();
			}).catch(() => {
				this.findAll();
			})

		},


		searchSetting(){
			var query = Object.assign({},this.$route.query);

			delete query.toDate;
			delete query.fromDate;
			delete query.isLong;
			delete query.isSecure;
			delete query.reservationTypeList;
			delete query.ntreeTicket;
			delete query.visitorName;
			delete query.visitorCompany;
			delete query.isPermited;

			if(this.dateRange){
				this.searchItem.fromDate = moment(this.dateRange[0]).valueOf();
				this.searchItem.toDate = moment(this.dateRange[1]).valueOf();
			}

			query = Object.assign(query, this.copyNew(this.searchItem));
			Object.keys(query).forEach(x => {
				if(query[x] == '' || query[x] == null)
					delete query[x]
			})
			return query;
		},
		goNtreeTicket(ticketNumber) {
			if(ticketNumber) {
				let url = `http://ntree.navercorp.com/staff/ticket/popup/${ticketNumber}.html`;
				window.open(url);
			}
		},
		itemClick(item){
			if(this.selectedIndex != item.uuid)
				this.selectedIndex = item.uuid;
			else
				this.selectedIndex = null;
		},
		downloadExcel(){
			var query = this.searchSetting();
			this.$http.get('/api/private/visitor/history/download', {params: query, responseType: 'blob'},)
				.then(function(result) {
					const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/octet-stream'}));
					const link = document.createElement('a');
					link.href = url;

					let fileName = this.currentIdc.locationName + " "+ this.getDueDateFormat(this.searchItem.fromDate, this.searchItem.toDate, 'YYYYMMDD', '_') +' 출입이력.xlsx';
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					link.remove();
				}.bind(this)).catch((e) =>{
			})
		},
	}
}
</script>

<style lang="scss" scoped>
</style>
